// Excludes null, undefined, and NaN, which passes numeric type checks but formats as the literal "NaN".
export function hasDefinedValue(value: unknown): boolean {
  return value !== null && value !== undefined && !(typeof value === "number" && Number.isNaN(value))
}
